import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@styles/index.css';
import { RouterProvider } from 'react-router-dom';
import { AppProvider } from './context/AppProvider.jsx';
import './i18n';

// Dev-only: `npm run dev:mock` (Vite mode "mock") serves the admin API from
// in-memory fixtures so the UI is fully populated with no backend.
//
// The router is imported AFTER the mocks install: createBrowserRouter starts
// executing route loaders the moment the router module is evaluated, so the
// mocked axios adapter must already be in place by then. Production builds
// never load the mock module.
async function boot() {
  if (import.meta.env.MODE === 'mock') {
    const { installMocks } = await import('./mocks/install.js');
    installMocks();
  }
  const { default: router } = await import('./router/index.jsx');

  // White-label theming: kick off the branding fetch as early as possible (non-blocking). The CSS
  // defaults are already Zermit, so B2C renders instantly and unchanged; a tenant's theme is
  // applied the moment its branding resolves.
  const { useBrandingStore } = await import('./stores/useBranding.store.js');
  useBrandingStore.getState().loadBranding();

  createRoot(document.getElementById('root')).render(
    // <StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
    // </StrictMode>
  );
}

boot();
